/**
 * Do NOT use cellStyle or cellRender at this file
 */
export const COLUMN_TYPES = {
  tags: {
    minWidth: 150,
    valueSetter: params => {
      const str = params.newValue.replace(/\s/g, '').replace(/x|х|Х|X/g, '*');
      params.data[params.colDef.field] = str.split(',');
      return true;
    },
  },
  number: {
    valueSetter: params => {
      if (typeof params.newValue === 'string') {
        const str = params.newValue.replace(/,|\s/g, '');
        params.data[params.colDef.field] = str;
      }
      return true;
    },
  },
  chinaCurrency: {
    valueSetter: params => {
      if (typeof params.newValue === 'string') {
        const str = params.newValue.replace(/,|\s|¥/g, '');
        params.data[params.colDef.field] = str;
      }
      return true;
    },
    valueGetter: params => {
      if (params.data[params.colDef.field]) {
        return `¥ ${params.data[params.colDef.field]}`;
      }
    },
  },
  USDTCurrency: {
    minWidth: 130,
    valueSetter: params => {
      if (typeof params.newValue === 'string') {
        const str = params.newValue.replace(/,|\s|USDT/g, '');
        params.data[params.colDef.field] = str;
      }
      return true;
    },
    valueGetter: params => {
      const value = params.data[params.colDef.field];
      if (value) {
        return `USDT ${parseFloat(value).toFixed(2)}`;
      }
    },
  },
  weight: {
    valueSetter: params => {
      if (typeof params.newValue === 'string') {
        const str = params.newValue.replace(/,|\s|кг/g, '');
        params.data[params.colDef.field] = str;
      }
      return true;
    },
    valueGetter: params => {
      if (params.data[params.colDef.field]) {
        return `${params.data[params.colDef.field]} кг`;
      }
    },
  },
  link: {
    minWidth: 200,
  },
  box: {
    headerClass: 'table-box-header',
  },
  date: {
    valueGetter: params => {
      const value = params.data[params.colDef.field] || '';
      const date = new Date(value);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const hours = date.getHours();
      const minutes = date.getMinutes();
      return `${day < 10 ? `0${day}` : day}.${
        month < 10 ? `0${month}` : month
      }.${date.getFullYear()} ${hours < 10 ? `0${hours}` : hours}:${
        minutes < 10 ? `0${minutes}` : minutes
      }`;
    },
  },
};
